import React from 'react';
import { Grid, TextField, MenuItem, Typography, Divider, Box } from '@mui/material';
import { labOptions } from '../constants/options';

const LabOrdersSection = ({ formData, setFormData }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 600 }}>Lab Orders</Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={3}>
        {["Pathology", "Cytology", "Microbiology", "Biochemistry"].map((type) => (
          <Grid item xs={12} sm={6} key={type}>
            <TextField
              fullWidth
              select
              label={`Select ${type}`}
              name={`lab_${type.toLowerCase()}`}
              value={formData[`lab_${type.toLowerCase()}`] || "No"}
              onChange={(e) =>
                setFormData(prev => ({
                  ...prev,
                  [`lab_${type.toLowerCase()}`]: e.target.value,
                }))
              }
            >
              {labOptions.map((opt) => (
                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
              ))}
            </TextField>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LabOrdersSection;
